module.exports = __webpack_public_path__ + "cc9810c8d9c65565cc2f3c83ebd5b3f8.svg";